<template>
  <div class="content">
  <v-layout column>
    <v-flex xs12 sm6>
      <!-- <v-card flat> -->
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex
              v-for="card in projects.slice(0, 8).reverse()"
              v-bind="{ [`xs${cardFlex * 2}`]: true, [`sm${cardFlex}`]: true }"
              :key="card.title"
              @click="showProject(card)"
            >
              <v-card hover raised height="49vh">
                <v-card-media
                  :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + card.main_image"
                  height="50vh"
                >
                  <div class="left-top-gradient"></div>
                  <v-container fill-height fluid>
                    <v-layout fill-height>
                      <v-flex xs12 align-end flexbox>
                        <span class="headline white--text card-title" v-text="card.name" style="position:relative;"></span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-media>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      <!-- </v-card> -->
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import Api from '@/api'

export default {
  data: () => ({
    // cards: [
    //   // { title: 'Sienna', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/sienna-header.jpg', flex: 12 },
    //   { title: 'Jade', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/background4.jpg', flex: 3 },
    //   { title: 'Sienna', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/background5.jpg', flex: 3 },
    //   { title: 'Mia', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/background6.jpg', flex: 3 },
    //   { title: 'Tiana', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/background1.jpg', flex: 3 }
    // ]
    cardFlex: 3,
    projects: [],
    projectDetails: []
  }),
  beforeMount () {
    this.getProjectsData()
  },
  methods: {
    ...mapActions({
      updateActiveProjectID: 'projects/updateActiveProjectID',
      updateActiveProjectName: 'projects/updateActiveProjectName',
      updateActiveProjectDetails: 'projects/updateActiveProjectDetails',
      updateActiveProjectLocation: 'projects/updateActiveProjectLocation'
    }),
    showProject (card) {
      this.getProjectDetails(card)
    },
    getProjectsData () {
      const path = '/project/frontpage'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.projects = response.data.project
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    getProjectDetails (project) {
      const path = '/project/' + project.id
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.updateActiveProjectDetails(response.data.project_details)
            this.updateActiveProjectName(project.name)
            this.updateActiveProjectLocation(project.location)
            this.updateActiveProjectID(project.id)
            this.$router.push('/works/' + project.name)
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
.left-top-gradient {
  z-index: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.5;
  /*background-image:linear-gradient(120deg,rgba(0,0,0, 1),rgba(255,255,255,0));*/
  background-image: radial-gradient(at top left, rgba(0,0,0,1), rgba(0,0,0,0.1), rgba(255,255,255,0));
}
</style>


// WEBPACK FOOTER //
// src/components/ProjectsCard.vue